import api, { fetchAllPages } from "./client";

export const asistenciasApi = {
  getAll: (params = {}) => fetchAllPages("/asistencias/", params),
  getSummary: async (fecha) => (await api.get("/asistencias/resumen/", { params: { fecha } })).data,
  create: (data) => api.post("/asistencias/", data),
  update: (id, data) => api.patch(`/asistencias/${id}/`, data),
  remove: (id) => api.delete(`/asistencias/${id}/`),
};
